import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import ScheduledLesson from '@/models/ScheduledLesson';
import { formatLessonDate } from '@/utils/scheduledLessons/formatLessonDate';
import { getScheduledLessonStatus } from '@/utils/scheduledLessons/scheduledLessonStatus';
import ScheduledLessonStatusBadge from '../scheduled-lesson/ScheduledLessonStatusBadge';
import { formatLessonName } from '@/utils/lesson/name';

interface ReportScheduleLessonHeaderProps {
  scheduledLesson?: ScheduledLesson;
  klassDuration?: number;
}

export const ReportScheduleLessonHeader = ({
  scheduledLesson,
  klassDuration,
}: ReportScheduleLessonHeaderProps) => {
  const lessonDate = formatLessonDate(scheduledLesson?.datetime);

  return (
    <header className="grid grid-cols-2 gap-1">
      <div>
        <h2 className="text-lg font-bold">
          {formatLessonName(scheduledLesson?.lesson, scheduledLesson)}
        </h2>
        <p className="text-base font-medium leading-7">{lessonDate}</p>
        <ConditionalRenderer condition={scheduledLesson}>
          <ScheduledLessonStatusBadge
            status={getScheduledLessonStatus(
              {
                datetime: scheduledLesson?.datetime ?? '',
                hasDone: !!scheduledLesson?.hasDone,
              },
              klassDuration,
            )}
          />
        </ConditionalRenderer>
      </div>
    </header>
  );
};
